import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { SemanticPathService } from '@spartacus/core'
import { ActiveCartFacade } from '@spartacus/cart/base/root'

@Component({
  selector: 'mb-cart-po-upload',
  templateUrl: './mb-cart-po-upload.component.html'
})
export class MbCartPoUploadComponent {

  entries$ = this.activeCartService.getEntries()

  constructor (protected router: Router,
               protected semanticPathService: SemanticPathService,
               protected activeCartService: ActiveCartFacade) { }

  goToPOUpload () {
    return this.router.navigate([this.semanticPathService.get('poUpload')])
  }
}
